import { isEqual } from "lodash";
import { useState, useCallback } from "react";

import { OutgoingMailStatusDTO, OutgoingMailStatusRef } from "src/models/outgoing-mail-status";
import { OutgoingMailStatusQuickFilter } from "./interfaces";

export const useOutgoingMailStatusQuickFilter = (defaultValue?: OutgoingMailStatusRef[]) => {
  const [quickFilter, setQuickFilter] = useState<OutgoingMailStatusQuickFilter>({
    outgoingMailStatuses: {
      outgoingMailStatusIds: defaultValue ? [...defaultValue.map((item) => item.id)] : [],
    },
  });

  const [selectedOutgoingMailStatus, setSelectedOutgoingMailStatus] = useState<OutgoingMailStatusRef | null>(
    defaultValue ? defaultValue[0] : null
  );

  const handleChangeQuickFilter = useCallback(
    (
      filter: keyof OutgoingMailStatusQuickFilter,
      value: OutgoingMailStatusQuickFilter["outgoingMailStatuses"],
      item: OutgoingMailStatusDTO | null
    ) => {
      if (isEqual(value, quickFilter[filter])) return;

      setQuickFilter((state) => ({ ...state, [filter]: value }));
      setSelectedOutgoingMailStatus(item);

      // localStorage.setItem("QF_IMS", JSON.stringify(value));
    },
    [quickFilter]
  );

  return {
    outgoingMailStatusQuickFilter: quickFilter,
    setOutgoingMailStatusQuickFilter: handleChangeQuickFilter,
    selectedOutgoingMailStatus,
  };
};
